import React, { useState, useEffect } from "react";
import { Table, Dialog, Message } from "@jdcfe/legao";
import CreateAppInput from "components/CreateAppInput";
// import { deleteApp,queryCreateApp } from 'utils/api';
import { queryCreateApp } from "utils/api";
import { observer } from "mobx-react-lite";
import useStore from "stores";
import { useHistory } from "react-router-dom";
import "./style.scss";

const AppList = observer(() => {
  // const [ tableData ,setTableData ] = useState([]);
  const [createLoading, setCreateLoading] = useState(false);
  const { overviewStore } = useStore();
  const history = useHistory();
  useEffect(() => {
    // const history = useHistory();
    overviewStore.getHistory(history);
    overviewStore.getApplist();
  }, [history]);

  const tableTitle = [
    {
      title: "应用名称",
      dataIndex: "appName",
      key: "appName",
      // width: 288
    },
    {
      title: "AppKey",
      dataIndex: "appKey",
      key: "appKey",
      // width: 412
    },
    {
      title: "ClientId",
      dataIndex: "clientId",
      key: "clientId",
      // width: 188
    },
    {
      title: "操作",
      dataIndex: "handleAppInfo",
      key: "handleAppInfo",
      // width: 169
    },
  ];

  const handleCreate = () => {
    const createapp = Dialog.confirm({
      title: "创建应用",
      children: <CreateAppInput></CreateAppInput>,
      wrapStyle: {
        zIndex: 99,
      },
      actions: [
        {
          text: "提交",
          onClick: () => {
            sureClick(createapp);
          },
          className: "sure",
          styleType: "primary",
          autoClose: false,
        },
        {
          text: "取消",
          onClick: () => createapp.close(),
          className: "cancel",
          styleType: "",
        },
      ],
      className: "create_dialog",
    });
  };
  const sureClick = (createapp) => {
    const appName = document.querySelector(".appName .lg-input-o").value;
    const authCallbackUrl = document.querySelector(
      ".authCallbackUrl .lg-input-o"
    ).value;
    const developerPhone = document.querySelector(".developerPhone .lg-input-o")
      .value;
    const developerEmail = document.querySelector(".developerEmail .lg-input-o")
      .value;
    if (createLoading) {
      Message.showMsg({
        showIcon: true,
        type: "warn",
        description: "请稍等再试",
        autohide: true,
        closable: false,
        duration: 3000,
      });
      return;
    }
    setCreateLoading(true);
    queryCreateApp({
      appName,
      authCallbackUrl,
      developerPhone,
      developerEmail,
    }).then((res) => {
      if (document.querySelector(".input_item.error")) document.querySelector(".input_item.error").classList.remove("error");
      if (!res.data.success) {
        if (res.data.resultCode === "30000005") {
          document
            .querySelector(".appName")
            .parentNode.setAttribute("class", "input_item error");
          document.querySelector(".appName").nextSibling.innerHTML = res.data.resultMessage;
        } else if (res.data.resultCode === "30000006") {
          document
            .querySelector(".authCallbackUrl")
            .parentNode.setAttribute("class", "input_item error");
          document.querySelector(".authCallbackUrl").nextSibling.innerHTML = res.data.resultMessage;
        } else if (res.data.resultCode === "30000007") {
          document
            .querySelector(".developerEmail")
            .parentNode.setAttribute("class", "input_item error");
          document.querySelector(".developerEmail").nextSibling.innerHTML = res.data.resultMessage;
        } else if (res.data.resultCode === "30000008") {
          document
            .querySelector(".developerPhone")
            .parentNode.setAttribute("class", "input_item error");
          document.querySelector(".developerPhone").nextSibling.innerHTML = res.data.resultMessage;
        }else{
          Message.showMsg({
            showIcon: true,
            type: "wrong",
            description:res.data.resultMessage,
            autohide: true,
            closable: false,
            duration: 1000,
          });
        }
      } else {
        Message.showMsg({
          showIcon: true,
          type: "success",
          description: "创建成功",
          autohide: true,
          closable: false,
          duration: 1000,
        });
        setTimeout(() => {
          overviewStore.getApplist().then(() => {
            createapp.close();
          });
        }, 1000);
      }
      setCreateLoading(false);
    });
  };
  const handleBack = () =>{
    // history.go(-1);
    location.href = '/app/frame/overview';
  };

  return (
    <div className="app_list">
      <div className="list_title">
        <div className="app_guide" onClick={handleBack}>
          <i className="guide_arrow"></i>
          返回
        </div>
        <div className="list_create_app">
          <button onClick={handleCreate}> <span>+</span>创建应用</button>
        </div>
      </div>
      <div className="list_content">
        <div className="content_contain">
          <Table
            className="app_table"
            columns={tableTitle}
            data={overviewStore.appListTableData}
            emptyText={"暂无应用，请先创建"}
          />
        </div>
      </div>
    </div>
  );
});
export default AppList;
